import React from 'react';
import { Heading, Link as ChakraLink, Text, Wrap, WrapItem } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useRouteMatch } from 'react-router';
import './projects.css';
import { ProjectButton95, ProjectCard95 } from './ProjectCard95';

export const Projects: React.FC = (props) => {
    let { url } = useRouteMatch();

    return (
        <>
            <Heading mb={12}>Projects</Heading>
            <Wrap justify="center">
                <WrapItem>
                    <ProjectCard95 title="TSConfig Viewer" color="blue">
                        <ProjectCard95.Body>
                            <Text>
                                A VS Code extension that displays the complete TypeScript configuration for <Text display="inline" fontFamily="monospace">tsconfig</Text> files in monorepo setups.
                            </Text>
                        </ProjectCard95.Body>
                        <ProjectCard95.Footer>
                            <a
                                href="https://github.com/dennyferra/tsconfig-viewer"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <ProjectButton95 title="TSConfig Viewer" external />
                            </a>
                        </ProjectCard95.Footer>
                    </ProjectCard95>
                </WrapItem>

                <WrapItem>
                    <ProjectCard95 title="Pizza Value Calculator" color="teal">
                        <ProjectCard95.Body>
                            <Text>A simple calculator that compares pizzas based on price per unit area.</Text>
                            <Text fontSize="sm" mt={4}>Answer the age old question: Which pizza gives you more food for your money?</Text>
                        </ProjectCard95.Body>
                        <ProjectCard95.Footer>
                            <Link to={`${url}/pizza`}>
                                <ProjectButton95 title="Pizza Value Calculator" />
                            </Link>
                        </ProjectCard95.Footer>
                    </ProjectCard95>
                </WrapItem>

                <WrapItem>
                    <ProjectCard95 title="Nature of Code" color="brick">
                        <ProjectCard95.Body>
                            <Text>
                                An <Text display="inline" fontFamily="monospace">in-progress</Text> run through of The Nature of Code (<ChakraLink href="https://www.natureofcode.com" target="_blank" colorScheme="teal">natureofcode.com</ChakraLink>).
                            </Text>
                        </ProjectCard95.Body>
                        <ProjectCard95.Footer>
                            <Link to={`${url}/natureofcode`}>
                                <ProjectButton95 title="Nature of Code" />
                            </Link>
                        </ProjectCard95.Footer>
                    </ProjectCard95>
                </WrapItem>

                <WrapItem>
                    <ProjectCard95 title="TypeWatch" color="purple">
                        <ProjectCard95.Body>
                            <Text>
                                A jQuery plugin that triggers a callback after a user stops typing in an input after a specified delay (debounce).
                            </Text>
                        </ProjectCard95.Body>
                        <ProjectCard95.Footer>
                            <a
                                href="https://github.com/dennyferra/TypeWatch"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <ProjectButton95 title="TypeWatch" external />
                            </a>
                        </ProjectCard95.Footer>
                    </ProjectCard95>
                </WrapItem>
            </Wrap>
        </>
    );
};
